<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system';
	//Types
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import type { VirtualDeviceTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_types';

	export let template: VirtualDeviceTemplate;
	export let statuses: VCInterfaceStatus[];

	const invalidTemplate = (statuses: VCInterfaceStatus[]): string => {
		for (let [role, component] of Object.entries(template || {})) {
			if (role === 'type') continue;
			if (!statuses.find((i) => i?.component === component)) return component;
		}
		return null;
	};

	$: invalid = invalidTemplate(statuses);
</script>

{#if invalid}
	<Alert
		class="mb-s"
		type="danger"
		heading={$format(`vc_template_missing_component`, { default: 'Template component is missing.' })}
		isHeadingBold
		message={$format(`device_component_missing`, { default: 'Device component is missing' }) +
			': ' +
			invalid}
	/>
{/if}
